export default __webpack_public_path__ + "static/media/spce-logo.e4da8637.png";